<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_5"></a>contents</h2>
<p class="toc"><a href="#/xhtml/fm02">introduction</a></p>
<p class="toc"><a href="#/xhtml/chapter01">menu planning</a></p>
<p class="toc"><a href="#/xhtml/chapter02">pickles</a></p>
<p class="toc"><span href="#/xhtml/chapter03" title="Link target outside of Sample">breads &amp; pies</span></p>
<p class="toc"><span href="#/xhtml/chapter04" title="Link target outside of Sample">yoghurt &amp; soups</span></p>
<p class="toc"><span href="#/xhtml/chapter05" title="Link target outside of Sample">rice</span></p>
<p class="toc"><span href="#/xhtml/chapter06" title="Link target outside of Sample">fish &amp; eggs</span></p>
<p class="toc"><span href="#/xhtml/chapter07" title="Link target outside of Sample">kibbi</span></p>
<p class="toc"><span href="#/xhtml/chapter08" title="Link target outside of Sample">meat &amp; poultry</span></p>
<p class="toc"><span href="#/xhtml/chapter09" title="Link target outside of Sample">vegetables &amp; salads</span></p>
<p class="toc"><span href="#/xhtml/chapter10" title="Link target outside of Sample">sweets, preserves &amp; refreshing drinks</span></p>
<p class="toc"><span href="#/xhtml/bm01" title="Link target outside of Sample">glossary</span></p>
<p class="image"><img alt="Illustration" src="images/f0005-01.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?06800a84